import React, { useState, useEffect } from "react";
import {
  DeleteSharp,
  Add,
  ArrowLeft,
  RemoveRedEye,
  EditSharp,
  Schedule
} from "@mui/icons-material";
import {
  Card,
  Stack,
  Container,
  Typography,
  Button,
  Tooltip,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Badge
} from "@mui/material";
import DataTable from "react-data-table-component";
import Page from "../components/Page";
import {
  deletePoll,
  getPollPrimeResult,
  insertPrimePoll,
  updatePrimePoll,
  getPollChildren
} from "src/api/commonapi";
import { fetchPrimeAllPollList } from "src/utils/common";
import { notification } from "src/utils/messages";
import Modal from "@mui/material/Modal";
import Deletemodal from "./DeleteModal";
import DeleteConfirmDialog from "./Notification/DeleteConfirmDialog";
import { CSVLink } from "react-csv";
import moment from "moment";
import CustomLoader from "src/components/CustomLoader";
import PollFilters from "./Poll/PollFilters";
import PollForm from "./Poll/PollForm";
import PollScheduleModal from "./Poll/PollScheduleModal";

export default function Poll() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));

  const [pollPage, setPollPage] = useState(0); // 0=list, 1=add, 2=edit
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [polldata, setpolldata] = useState([]);
  const [pollResult, setPollResult] = useState({});
  const [answerUser, setAnswerUser] = useState(0);
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [myModal, setMyModal] = useState(false);
  const [editingPoll, setEditingPoll] = useState(null);
  const [showValidation, setShowValidation] = useState(false);
  // Field/schedule lock — applies only once the batch has actually been sent
  const [sentLocked, setSentLocked] = useState(false);

  const [pollFilters, setPollFilters] = useState({
    p_type: 0,
    poll_status: 0,
    poll_send_status: -1,
    search: ""
  });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    totalRecords: 0
  });
  const [openPreview, setOpenPreview] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deletedCount, setDeletedCount] = useState(null);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [scheduleParentRow, setScheduleParentRow] = useState(null);

  const [getdata, setgetdata] = useState({
    p_type: 4,
    p_type_id: "",
    question: "",
    show_on_home: 0,
    p_to: "0"
  });
  const [answer, setanswer] = useState([]);

  // p_to labels — same as Notification To
  const P_TO_OPTIONS = [
    { label: "All", value: "0" },
    { label: "Orange Tick", value: "7" },
    { label: "Not Orange Tick", value: "8" }
  ];

  const getToLabel = (val) => P_TO_OPTIONS.find((o) => String(o.value) === String(val))?.label || "-";

  // Parse p_type_id from API: "[5]" → "5", "[1,3,5]" → "1,3,5"
  const parsePTypeId = (val) => {
    if (!val) return "";
    try {
      const parsed = JSON.parse(val);
      if (Array.isArray(parsed)) return parsed.join(",");
      return String(parsed);
    } catch {
      return String(val);
    }
  };

  const parsePollAnswers = (val) => {
    if (!val) return [];
    if (Array.isArray(val)) return val;
    if (typeof val === "string") {
      try {
        const parsed = JSON.parse(val);
        if (Array.isArray(parsed)) return parsed;
      } catch {}
      if (val.includes("|||")) return val.split("|||").filter((s) => s !== "");
      return [val];
    }
    return [];
  };

  // Modal Style
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 4
  };

  const getPollList = async (page = 1, perPage = 10, filters = pollFilters) => {
    setLoading(true);
    try {
      const result = await fetchPrimeAllPollList(loginUser.u_type, {
        page,
        limit: perPage,
        p_type: filters.p_type,
        poll_status: filters.poll_status,
        poll_send_status: filters.poll_send_status,
        search: filters.search
      });
      if (result.data) {
        setpolldata(result.data);
        setPagination({
          currentPage: result.pagination?.current_page || 1,
          perPage: result.pagination?.per_page || 10,
          totalRecords: result.pagination?.total_records || 0
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    getPollList(newPage, pagination.perPage);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    getPollList(page, newPerPage);
  };

  useEffect(() => {
    getPollList(1, pagination.perPage, pollFilters);
  }, [pollFilters]);

  // Delete Poll
  const deletepoll = async (p_id) => {
    const resp = await deletePoll(p_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message
    });
    notify();
    if (resp.status == 1) {
      setDvisible({ mval: false, id: 0 });
      getPollList(pagination.currentPage, pagination.perPage);
    }
  };

  const handleDeleteClick = (row) => {
    if (row.sub_count > 0) {
      setDeleteTarget(row);
      setDeletedCount(null);
      setDeleteDialogOpen(true);
    } else {
      setDvisible({ mval: true, id: row.p_id });
    }
  };

  const handleConfirmDelete = async () => {
    if (!deleteTarget) return;
    const resp = await deletePoll(deleteTarget.p_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message:
        resp.status === 1 && resp.deleted_count
          ? `${resp.deleted_count} poll${resp.deleted_count !== 1 ? "s" : ""} deleted successfully`
          : resp.message
    });
    notify();
    if (resp.status === 1) {
      setDeleteDialogOpen(false);
      setDeleteTarget(null);
      setDeletedCount(null);
      getPollList(pagination.currentPage, pagination.perPage);
    }
  };

  // Get Poll Result
  const getPollResult = async (p_id) => {
    const resp = await getPollPrimeResult(p_id);
    if (resp.status != 0) {
      setPollResult(resp);
    }
  };

  const cancelModal = () => {
    setMyModal(false);
  };

  const handleEdit = async (row) => {
    setLoading(true);
    try {
      const resp = await getPollChildren(row.p_id);
      if (resp.status === 1) {
        const isSubClick = String(row.is_main) === "0" && row.p_id != undefined;
        let rows;
        let allBatchRows = Array.isArray(resp.data) ? resp.data : [];
        if (isSubClick) {
          // Editing a SUB entry -> scope the form to just that entry (Privilege parity).
          // The children endpoint is keyed on the PARENT id, so querying the sub's own
          // p_id returns [] — fetch the parent's children to learn what the siblings
          // are set to (needed for the single "Send Immediately" slot).
          const parentId = row.p_parent_id ?? row.parent_p_id ?? row.p_parentId;
          if (parentId != undefined && parentId !== null && String(parentId) !== String(row.p_id)) {
            try {
              const parentResp = await getPollChildren(parentId);
              if (parentResp.status === 1 && Array.isArray(parentResp.data)) {
                allBatchRows = [...parentResp.data, row];
              }
            } catch {
              // keep allBatchRows as-is; immediate slot simply stays unguarded
            }
          }
          rows = [row];
        } else {
          rows = Array.isArray(resp.data) ? [...resp.data] : [];
          // Single poll has no children (data: []) — use clicked row as main
          if (rows.length === 0) {
            rows = [{ ...row, is_main: 1 }];
          } else if (!rows.some((e) => String(e.is_main) === "1")) {
            rows = [{ ...row, is_main: 1 }, ...rows];
          }
          rows.sort(
            (a, b) => (String(b.is_main) === "1" ? 1 : 0) - (String(a.is_main) === "1" ? 1 : 0)
          );
        }
        const mainEntry = isSubClick ? row : rows.find((e) => String(e.is_main) === "1") || rows[0];
        // p_id of whichever entry in the whole batch currently claims "Send Immediately"
        // Poll exposes the send type as poll_send_type (see entries mapping below)
        const pollSendTypeOf = (e) =>
          String(e.poll_send_type ?? e.notification_send_type ?? "0");
        const immediateHolder = allBatchRows.find(
          (e) => pollSendTypeOf(e) === "1" && String(e.p_id) !== String(row.p_id)
        );
        // The children endpoint returns subs only, so the MAIN entry's send type is not in
        // allBatchRows — fall back to the value carried over from the list row.
        const parentIsImmediate = String(row.parent_send_type) === "1";
        const immediateHolderId = immediateHolder
          ? immediateHolder.p_id
          : parentIsImmediate
            ? row.p_parent_id ?? row.parent_p_id ?? row.p_parentId ?? "__parent_immediate__"
            : pollSendTypeOf(row) === "1"
              ? row.p_id
              : null;
        const entries = rows.map((e) => ({
          s_date: e.s_date,
          e_date: e.e_date,
          // Poll children expose the send type as poll_send_type; notification_send_type
          // is the shared name ScheduleEntryRow reads. Fall back across both so a
          // "Send Immediately" poll doesn't render as "Schedule for later".
          notification_send_type: String(
            e.poll_send_type ?? e.notification_send_type ?? "0"
          ),
          n_date_time: e.n_date_time || e.p_date_time || "",
          show_on_home: e.show_on_home || 0,
          p_id: e.p_id,
          p_parent_id: e.p_parent_id,
          is_main: String(e.is_main) === "1" ? 1 : 0,
          // Batch-wide immediate slot holder, so a sub-only form still sees it
          batch_immediate_holder_id: immediateHolderId,
          // Poll uses poll_send_status; mirror it onto the shared field name that
          // ScheduleEntryRow inspects for per-entry locking
          notification_send_status:
            e.poll_send_status !== undefined ? e.poll_send_status : e.notification_send_status,
          _uid: `entry_${e.p_id || e.p_parent_id || Date.now()}_${Math.random().toString(36).slice(2, 6)}`
        }));
        // Record-level lock: only when EVERY entry of this batch has been sent.
        // Partially-sent batches stay fully editable at form level so remaining
        // unsent entries can still have all their dates adjusted.
        const allSent =
          rows.length > 0 && rows.every((e) => String(e.poll_send_status) === "1");
        setSentLocked(allSent);
        setEditingPoll({ ...mainEntry, p_id: mainEntry.p_id });
        setgetdata({
          p_type: mainEntry.p_type || 4,
          p_type_id: parsePTypeId(mainEntry.p_type_id),
          question: mainEntry.p_question || "",
          show_on_home: mainEntry.show_on_home || 0,
          p_to: String(mainEntry.p_to ?? "0"),
          schedule_entries: entries
        });
        setanswer(
          parsePollAnswers(mainEntry.p_answer).map((a) => ({ value: a }))
        );
        setPollPage(2);
      }
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setgetdata({
      p_type: 4,
      p_type_id: "",
      question: "",
      show_on_home: 0,
      p_to: "0",
      schedule_entries: [
        {
          s_date: moment().format("DD-MM-YYYY"),
          e_date: "",
          notification_send_type: "0",
          n_date_time: "",
          show_on_home: 0,
          _uid: `entry_${Date.now()}`
        }
      ]
    });
    setanswer([]);
    setEditingPoll(null);
    setShowValidation(false);
    setSentLocked(false);
  };

  const validationHandler = () => {
    if (!getdata.question) {
      notification({ type: "error", message: "Question is required" })();
      return false;
    }
    if (getdata.p_type != 4 && getdata.p_type != "4") {
      if (!getdata.p_type_id || getdata.p_type_id === "0" || getdata.p_type_id === 0) {
        notification({
          type: "error",
          message: "Please select a valid State/City option"
        })();
        return false;
      }
    }
    if (answer.length === 0 || answer.some((e) => !e.value)) {
      notification({ type: "error", message: "Please enter all answers" })();
      return false;
    }
    const entries = getdata.schedule_entries || [];
    if (!entries.length) {
      notification({
        type: "error",
        message: "At least one schedule entry is required"
      })();
      return false;
    }
    for (let i = 0; i < entries.length; i++) {
      const e = entries[i];
      if (!e.s_date) {
        notification({
          type: "error",
          message: `Entry ${i + 1}: Start date is required`
        })();
        return false;
      }
      if (!e.e_date) {
        notification({
          type: "error",
          message: `Entry ${i + 1}: End date is required`
        })();
        return false;
      }
      if (moment(e.e_date, "DD-MM-YYYY").isBefore(moment(e.s_date, "DD-MM-YYYY"))) {
        notification({
          type: "error",
          message: `Entry ${i + 1}: End date cannot be before start date`
        })();
        return false;
      }
      if (e.notification_send_type === "0" && !e.n_date_time) {
        notification({
          type: "error",
          message: `Entry ${i + 1}: Scheduled date/time is required`
        })();
        return false;
      }
      if (
        e.notification_send_type === "0" &&
        e.n_date_time &&
        e.s_date &&
        e.e_date
      ) {
        const sendDateTime = moment(e.n_date_time, "DD-MM-YYYY hh:mm A");
        const start = moment(e.s_date, "DD-MM-YYYY").startOf("day");
        const end = moment(e.e_date, "DD-MM-YYYY").endOf("day");
        if (sendDateTime.isBefore(start) || sendDateTime.isAfter(end)) {
          notification({
            type: "error",
            message: `Entry ${i + 1}: Send Date & Time must be between Start Date and End Date`
          })();
          return false;
        }
      }
    }
    const immediateCount = entries.filter(
      (e) => e.notification_send_type === "1" || e.notification_send_type === 1
    ).length;
    if (immediateCount > 1) {
      notification({
        type: "error",
        message: "Only one entry can be 'Send Immediately' per batch"
      })();
      return false;
    }
    return true;
  };

  const handleSubmitClick = () => {
    if (validationHandler()) setOpenPreview(true);
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      let fdata = new FormData();
      fdata.append("p_type", getdata.p_type);
      fdata.append("p_type_id", parsePTypeId(getdata.p_type_id) || "0");
      fdata.append("p_question", getdata.question);
      fdata.append("show_on_home", getdata.show_on_home);
      fdata.append("p_to", getdata.p_to || "0");
      answer.forEach((a) => {
        fdata.append("p_answer", a.value);
      });

      const schedulePayload = (getdata.schedule_entries || []).map((e) => {
        const obj = {
          s_date: e.s_date,
          e_date: e.e_date,
          notification_send_type: String(e.notification_send_type),
          n_date_time: e.n_date_time || "",
          show_on_home: e.show_on_home || 0
        };
        if (editingPoll && e.p_id) obj.p_id = e.p_id;
        return obj;
      });
      fdata.append("schedule_entries", JSON.stringify(schedulePayload));

      let resp;
      if (editingPoll) {
        fdata.append("p_id", editingPoll.p_id);
        fdata.append("linked_edit", "1");
        resp = await updatePrimePoll(fdata);
      } else {
        resp = await insertPrimePoll(fdata);
      }

      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
      if (resp.status == 1) {
        resetForm();
        setPollPage(0);
        getPollList(pagination.currentPage, pagination.perPage);
        setOpenPreview(false);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const export_readPollDetailColumns = [
    { label: "Person Name", key: "m_name" },
    { label: "City Name", key: "city_name" }
  ];

  const modifiedData = polldata?.map((item, index) => ({
    no: index + 1,
    p_question: item.p_question,
    s_date: item.s_date,
    e_date: item.e_date
  }));

  const expo_columns = [
    { label: "No", key: "no" },
    { label: "Poll Question", key: "p_question" },
    { label: "Start Date", key: "s_date" },
    { label: "End Date", key: "e_date" }
  ];

  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={deletepoll} />
      <DeleteConfirmDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={handleConfirmDelete}
        subCount={deleteTarget?.sub_count || 0}
        deletedCount={deletedCount}
      />
      <Modal
        open={myModal}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Poll Result
          </Typography>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "280px", overflowY: "scroll" }}>
              <div className="Poll_details">
                <div
                  className="question"
                  style={{
                    padding: "5px 0",
                    justifyContent: "start",
                    alignItems: "center"
                  }}
                >
                  <b> Poll Question &nbsp;</b> : {pollResult.question}
                </div>
                <div
                  className="ans_counter"
                  style={{
                    padding: "5px 0",
                    justifyContent: "start",
                    alignItems: "center"
                  }}
                >
                  <b> Total Answer &nbsp;</b> : {pollResult.total_vote}
                </div>
              </div>

              <div className="poll_question">
                <b> Poll Answers &nbsp;</b> <br />
                {pollResult.option?.map((e) => {
                  var pre =
                    Math.round(
                      ((e.vote_counter * 100) / pollResult.total_vote + Number.EPSILON) * 100
                    ) / 100;

                  return (
                    <>
                      <div
                        className="answerList"
                        style={{
                          display: "flex",
                          marginTop: "10px",
                          paddingBottom: "10px",
                          marginBottom: "10px"
                        }}
                        onClick={() => {
                          setAnswerUser(e.p_c_id);
                        }}
                      >
                        <div className="answer" style={{ marginRight: "20px" }}>
                          {e.p_c_option}
                        </div>
                        <div
                          style={{
                            width: "50%",
                            border: "1px solid #00ab55",
                            borderRadius: "20px"
                          }}
                        >
                          <div
                            style={{
                              width: pre + "%",
                              backgroundColor: "#00ab55",
                              color: "#fff",
                              padding: "0 10px ",
                              borderRadius: "20px"
                            }}
                          >
                            {e.vote_counter}
                          </div>
                        </div>
                        <div style={{ marginLeft: "20px" }}>
                          <p style={{ fontSize: "13px" }}>{pre + "%"}</p>
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "start",
                          marginBottom: "20px"
                        }}
                      >
                        <div
                          className="answerUser"
                          style={
                            answerUser != 0 && answerUser == e.p_c_id
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >
                          <table
                            style={{
                              border: "1px solid #000",
                              borderCollapse: "collapse"
                            }}
                          >
                            <tr>
                              <td
                                style={{
                                  border: "1px solid #000",
                                  borderCollapse: "collapse",
                                  padding: "5px"
                                }}
                              >
                                Persone Name
                              </td>
                              <td
                                style={{
                                  border: "1px solid #000",
                                  borderCollapse: "collapse",
                                  padding: "5px"
                                }}
                              >
                                City Name
                              </td>
                            </tr>
                            {pollResult.userlist?.map((us) => {
                              if (us.p_c_id == e.p_c_id) {
                                return (
                                  <>
                                    <tr>
                                      <td
                                        style={{
                                          border: "1px solid #000",
                                          borderCollapse: "collapse",
                                          padding: "5px"
                                        }}
                                      >
                                        {us.m_name}
                                      </td>
                                      <td
                                        style={{
                                          border: "1px solid #000",
                                          borderCollapse: "collapse",
                                          padding: "5px"
                                        }}
                                      >
                                        {us.city_name}
                                      </td>
                                    </tr>
                                  </>
                                );
                              }
                            })}
                          </table>
                        </div>
                        {answerUser != 0 &&
                          answerUser == e.p_c_id &&
                          pollResult.userlist?.filter((us) => us.p_c_id == e.p_c_id).length >
                            0 && (
                            <Button className="btn btn-export" style={{ marginLeft: "10px" }}>
                              <CSVLink
                                data={pollResult.userlist?.filter((us) => us.p_c_id == e.p_c_id)}
                                headers={export_readPollDetailColumns}
                                filename={`Poll Result.csv`}
                                className="btn btn-primary test"
                                target="_blank"
                              >
                                Export CSV
                              </CSVLink>
                            </Button>
                          )}
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button variant="outlined" onClick={cancelModal}>
                Close
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      {/* Preview Confirmation Dialog */}
      <Dialog open={openPreview} onClose={() => setOpenPreview(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ fontWeight: 700 }}>Preview Poll</DialogTitle>
        <DialogContent>
          <Typography variant="subtitle2" gutterBottom>
            Question: {getdata.question}
          </Typography>
          <Typography variant="subtitle2" gutterBottom>
            Answers: {answer.map((a) => a.value).join(", ")}
          </Typography>
          <Typography variant="subtitle2" gutterBottom>
            To: {getToLabel(getdata.p_to)}
          </Typography>
          <Divider sx={{ my: 1 }} />
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            Schedule Entries ({(getdata.schedule_entries || []).length})
          </Typography>
          {(getdata.schedule_entries || []).map((entry, idx) => (
            <Box key={idx} sx={{ p: 1, mb: 1, border: "1px solid #e0e0e0", borderRadius: 1 }}>
              <Typography variant="body2">
                Entry {idx + 1}: {entry.s_date} — {entry.e_date} |{" "}
                {entry.notification_send_type === "1"
                  ? "Immediate"
                  : `Scheduled: ${entry.n_date_time}`}{" "}
                | Show on Home: {entry.show_on_home ? "Yes" : "No"}
              </Typography>
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPreview(false)} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Confirm & Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      <PollScheduleModal
        open={scheduleModalOpen}
        parentRow={scheduleParentRow}
        onClose={() => {
          setScheduleModalOpen(false);
          setScheduleParentRow(null);
        }}
        onEdit={handleEdit}
        onDelete={handleDeleteClick}
        onViewResult={(p_id) => {
          getPollResult(p_id);
          setMyModal(true);
        }}
      />

      <Page title="Poll | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography variant="h4" gutterBottom className="mb-0">
              Poll
            </Typography>
            {pollPage === 0 ? (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  resetForm();
                  setPollPage(1);
                }}
              >
                <Add sx={{ fontSize: "20px", marginRight: "5px" }} />
                Add Poll
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="primary"
                disabled={isSubmitting}
                onClick={() => {
                  resetForm();
                  setPollPage(0);
                }}
              >
                <ArrowLeft sx={{ fontSize: "20px", marginRight: "5px" }} />
                Back
              </Button>
            )}
          </Stack>

          {pollPage === 0 ? (
            <>
              <PollFilters pollFilters={pollFilters} setPollFilters={setPollFilters} />
              <Card className="p-2" style={{ padding: "15px" }}>
                <Button className="btn btn-export">
                  <CSVLink
                    data={modifiedData || []}
                    headers={expo_columns}
                    filename={"PollData.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                {polldata && (
                  <DataTable
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={pagination?.totalRecords || 0}
                    paginationPerPage={pagination?.perPage || 10}
                    paginationDefaultPage={pagination?.currentPage || 1}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    columns={[
                      {
                        name: "No",
                        selector: (row, index) => index + 1,
                        sortable: true,
                        width: "70px"
                      },
                      { name: "Start Date", selector: (row) => row.s_date, sortable: true },
                      { name: "End Date", selector: (row) => row.e_date, sortable: true },
                      { name: "Poll Question", selector: (row) => row.p_question },
                      { name: "To", selector: (row) => getToLabel(row.p_to) },
                      {
                        name: "Schedules",
                        width: "100px",
                        center: true,
                        ignoreRowClick: true,
                        cell: (row) => {
                          const count = row.sub_count || 0;
                          if (count <= 0) return null;
                          return (
                            <Tooltip
                              title={`${count} schedule ${count === 1 ? "entry" : "entries"}`}
                            >
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setScheduleParentRow(row);
                                  setScheduleModalOpen(true);
                                }}
                              >
                                <Badge badgeContent={count} color="primary" max={99}>
                                  <Schedule fontSize="small" />
                                </Badge>
                              </IconButton>
                            </Tooltip>
                          );
                        }
                      },
                      {
                        name: "Action",
                        cell: (row) => {
                          return (
                            <>
                              <Tooltip title="Delete">
                                <IconButton onClick={() => handleDeleteClick(row)}>
                                  <DeleteSharp color="error" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Edit">
                                <IconButton onClick={() => handleEdit(row)}>
                                  <EditSharp color="warning" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="View Result">
                                <IconButton
                                  onClick={() => {
                                    getPollResult(row.p_id);
                                    setMyModal(true);
                                  }}
                                >
                                  <RemoveRedEye color="success" />
                                </IconButton>
                              </Tooltip>
                            </>
                          );
                        }
                      }
                    ]}
                    data={polldata}
                    progressPending={loading}
                    progressComponent={<CustomLoader />}
                  />
                )}
              </Card>
            </>
          ) : (
            <>
              <Card style={{ padding: "20px" }}>
                <PollForm
                getdata={getdata}
                setgetdata={setgetdata}
                answer={answer}
                setanswer={setanswer}
                editingPoll={editingPoll}
                showValidation={showValidation}
                setShowValidation={setShowValidation}
                isLoading={isSubmitting}
                loginUser={loginUser}
                onSubmit={handleSubmitClick}
                onCancel={() => {
                  resetForm();
                  setPollPage(0);
                }}
              />
              </Card>
            </>
          )}
        </Container>
      </Page>
    </>
  );
}
